import { Component, Input, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { checkInputsForText } from '../../design-system.helper';
import { DesignSystemService } from '../../design-system.service';

@Component({
  selector: 'model-attribute-grid',
  templateUrl: './model-attribute-grid.component.html',
  styleUrls: ['./model-attribute-grid.component.scss'],
})
export class ModelAttributeGridComponent implements OnInit, OnDestroy {
  @Input() alignItems?: string;
  @Input() isHorizontal?: boolean;
  @Input() columns?: number;
  @Input() context?: object;
  @Input() heading?: string;
  @Input() direction?: string;
  @Input() configs: any;
  private eventListener: () => void;

  constructor(
    private el: ElementRef,
    private designSystemService: DesignSystemService,
  ) {}

  ngOnInit(): void {
    const [configs, isHorizontal, context] = checkInputsForText([
      this.configs,
      this.isHorizontal,
      this.context,
    ]);

    this.configs = configs;
    this.isHorizontal = isHorizontal;
    this.context = context;

    this.eventListener = this.designSystemService.listenForAttributeUpdates(
      this,
      this.el.nativeElement,
    );
  }

  ngOnDestroy() {
    if (this.eventListener) {
      this.eventListener();
    }
  }
}
